module.exports = __webpack_public_path__ + "src/assets/images/placeholder-vehicle.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-vehicle.png
// module id = 2319
// module chunks = 4